import { getCookie } from './helpers';

// eslint-disable-next-line import/prefer-default-export
export function removeToCartTrigger(product) {
  window.dataLayer = window.dataLayer || [];
  const trackProduct = product.merchandise.product;
  window.dataLayer.push({
    event: 'ee.remove_from_cart',
    ecommerce: {
      items: [
        {
          item_name: `${trackProduct.title} - ${trackProduct.variants?.edges[0]?.node?.title}`,
          item_id: trackProduct.variants?.edges[0]?.node?.sku,
          item_variant: trackProduct.variants?.edges[0]?.node?.title, // replace with varian title
          item_variant_internal_id: product.merchandise.id.replace(
            'gid://shopify/ProductVariant/',
            '',
          ),
          parent_internal_id: trackProduct.id.replace(
            'gid://shopify/Product/',
            '',
          ),
          parent_item_name: trackProduct.title,
          // eslint-disable-next-line max-len
          parent_item_sku: trackProduct.variants?.edges[0]?.node?.sku, // replace with parent SKU value
          item_brand: 'Benchmade',
          handle: trackProduct.handle,
          price: trackProduct.variants?.edges[0]?.node?.priceV2.amount,
          availability: trackProduct.available,
          product_type: trackProduct.productType,
        },
      ],
    },
  });
}

export function addToCartTrigger(product, variant) {
  window.dataLayer = window.dataLayer || [];
  const eventSource = getCookie('eventSource');
  window.dataLayer.push({
    event: 'ee.add_to_cart',
    event_source: eventSource,
    products: [
      {
        quantity: 1,
        item_name: `${product.title} - ${variant.title}`,
        item_id: variant.id.replace('gid://shopify/ProductVariant/', ''),
        item_variant: variant.title,
        item_variant_internal_id: variant.id.replace(
          'gid://shopify/ProductVariant/',
          '',
        ),
        parent_internal_id: product.id.replace('gid://shopify/Product/', ''),
        parent_item_name: product.title,
        parent_item_sku: variant.sku,
        item_brand: product.vendor,
        handle: product.handle,
        price: parseFloat(variant.priceV2.amount),
        availability: product.available,
        product_type: product.productType,
      },
    ],
  });
}

export function viewItemTrigger(product, variant) {
  window.dataLayer = window.dataLayer || [];
  const eventSource = getCookie('eventSource');
  window.dataLayer.push({
    event: 'ee.view_item',
    event_source: eventSource,
    ecommerce: {
      currencyCode: window.Shopify.currency.active,
      value: parseFloat(variant.priceV2.amount),
      items: [
        {
          item_name: `${product.title} - ${variant.title}`,
          item_id: variant.sku,
          item_variant: variant.title,
          item_variant_internal_id: variant.id.replace(
            'gid://shopify/ProductVariant/',
            '',
          ),
          parent_internal_id: product.id.replace('gid://shopify/Product/', ''),
          parent_item_name: product.title,
          parent_item_sku: variant.sku,
          item_brand: product.vendor,
          handle: product.handle,
          price: parseFloat(variant.priceV2.amount),
          availability: product.available,
          product_type: product.productType,
        },
      ],
    },
  });
}
